export default "__VITE_ASSET__EqUHWj5f__"